export var TITLE = 'Qwen';
export var TEXT_MULTIPLE = 0.7;
export var SPACE_MULTIPLE = 0.2;
export var COLOR_PRIMARY = '#615ced';
export var COLOR_GRADIENT = 'linear-gradient(to right, #00055F,  #6F69F7)';